/**
 * use before the text you want to color
 *
 * @example devLog(
 *  LOG_COLORS.yellow,
 *  `text that is supposed to be yellow`
 *  )
 */
export const LOG_COLORS = {
  yellow: '\x1b[33m%s\x1b[0m',
  grey: '\x1b[%s\x1b[90m',
} as const

/**
 * encapsulates `console.log` to be only called during development
 * - logs only when you run `next dev` script
 */
export const devLog = (...args: Parameters<typeof console.log>) => {
  if (isProduction) {
    return
  }

  console.log(...args)
}

/**
 * encapsulates `console.warn` to be only called during development
 * - logs warning to the console only when you run `next dev` script
 */
export const devWarn = (...args: Parameters<typeof console.warn>) => {
  if (isProduction) {
    return
  }

  console.warn(...args)
}

/**
 * - `false` for `next dev` script
 * - `true` for `next start` script
 * https://nextjs.org/docs/api-reference/cli#development
 */
const isProduction = process.env.NODE_ENV !== 'development'
